import { normalizeDeliveryLimitsResponse } from "@store/slices/magentoApiSlice/utils/normalizeDeliveryLimitsResponse";
import type { DeepNonNullable, DeepOmit } from "@store/types";

import type { MagentoApiGetOrderDeliveryLimitsQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export type DeliveryLimits =
  | DeepNonNullable<DeepOmit<MagentoApiGetOrderDeliveryLimitsQueryResponse["getOrderDeliveryLimits"], "__typename">>
  | undefined;

export const getOrderDeliveryLimitsEndpoint = (builder: MagentoApiBuilder) => ({
  getOrderDeliveryLimits: builder.query<DeliveryLimits, void>({
    query: () => ({
      method: "getOrderDeliveryLimits",
      params: [],
    }),
    providesTags: [TAGS.ORDER_DELIVERY_LIMITS],
    transformResponse: ({ getOrderDeliveryLimits }: MagentoApiGetOrderDeliveryLimitsQueryResponse) =>
      normalizeDeliveryLimitsResponse(getOrderDeliveryLimits),
  }),
});
